"use client";

import { useUserProfile } from "@/hooks/useAuth";
import { useFeatureFlagsState } from "@/hooks/useFeatureFlags";
import { HeroSection } from "@/shared/ui/hero-section";
import { Footer } from "@/shared/ui/footer.dynamic";
import { DonateCtaButton } from "@/widgets/marketing/donate-cta-button";
import { HomeDashboardShell } from "@/widgets/dashboard/home-dashboard-shell.dynamic";
import { Header } from "@/widgets/header/header";
import { HeaderLayoutWrapper } from "@/widgets/header/header-layout-wrapper";

// Кнопка героя на главной. Скачивание десктопного приложения отсюда убрано
// намеренно — вместо него поддержка проекта.
const donateCta = (opts: { className: string; style: React.CSSProperties }) => (
  <DonateCtaButton className={opts.className} style={opts.style} />
);

export function HomePageClient() {
  const { data: profile } = useUserProfile();
  const { flags, isLoading: flagsLoading } = useFeatureFlagsState();

  return (
    <HeaderLayoutWrapper header={<Header />}>
      <main id="main-content" className="flex-1">
        {profile && flags.dashboard ? (
          <>
            <HeroSection hideFeaturesGrid ctaSlot={donateCta} />
            <HomeDashboardShell />
          </>
        ) : profile && flagsLoading ? (
          // KAN-944: вошедшему не показываем лендинг, пока не знаем флаг дашборда
          <HeroSection hideFeaturesGrid ctaSlot={donateCta} />
        ) : (
          <HeroSection ctaSlot={donateCta} />
        )}
      </main>
      <Footer />
    </HeaderLayoutWrapper>
  );
}
